export default __webpack_public_path__ + "static/media/FourdevLogo.d763fad1.png";